<script setup>
/* eslint-disable */
import { onMounted, onBeforeUnmount, watch, ref } from "vue";
import { useRouter } from 'vue-router';
import { useSocketStore } from '@/stores/socket';
import { useMarketsStore } from '@/stores/markets';
import { useLiveSportsStore } from '@/stores/live_sports';
import { useLiveSportOverview } from '@/stores/live_sport_overview';
import { useVirtualCourtStore } from '@/stores/virtual_court';
import { useGeneralStore } from '@/stores/general';
import { useFavouritesStore } from '@/stores/favourites';
import { useBestlineVideoStore } from '@/stores/bestline_video';
import { useLiveCourtStore } from '@/stores/live_court';
import { useI18n } from 'vue-i18n';
import LiveFixtureDoubleMarket from '@/components/live_sports/LiveFixtureDoubleMarket.vue';
import LiveSportOverviewCompetition from '@/components/live_sports/LiveSportOverviewCompetition.vue';
import LiveSportOverviewFavourites from '@/components/live_sports/LiveSportOverviewFavourites.vue';
import Loader from '../Common/Loader.vue'
import commonSvgs from '@/assets/svgs/commonSvgs.json';
import { SportsData } from '@/stores/Sports';
import { useLandingSportsStore } from "@/stores/landing_sports";
import emitter from "@/helpers/emmiter";

import LiveIcon from '@/components/Common/LiveIcon.vue';

const { t } = useI18n();
const svg_data = ref(commonSvgs);

const router = useRouter();
const socketStore = useSocketStore();
const marketsStore = useMarketsStore();
const liveSportsStore = useLiveSportsStore();
const liveSportOverviewStore = useLiveSportOverview();
const virtualCourtStore = useVirtualCourtStore();
const generalStore = useGeneralStore();
const favouritesStore = useFavouritesStore();
const SportsDataStore = SportsData();
const bestlineVideoStore = useBestlineVideoStore();
const liveCourtStore = useLiveCourtStore();

const show_primary_overview_market = ref(false);
const show_secondary_overview_market = ref(false);

const primary_overview_market = ref(null);
const secondary_overview_market = ref(null);

const competitions_closed = ref(false);

const show_scroll_to_top_button = ref(false);

const showVideoFixtures = () => {
	liveSportOverviewStore.setShowVideoFixtures()
}

const scrollToTop = () => {
	const container = document.querySelector('.live-tab-info');
	window.scrollTo({ top: 0 });

	if (container) {
		container.scrollTo({ top: 0 });
	}
};

const direction = ref(document.dir);

const splideOptions = ref({
	direction: direction.value,
	pagination: false,
	arrows: true,
	autoWidth: true,
	trimSpace: 'move',
	gap: '1rem',
	breakpoints: {
		640: {
			gap: '1rem',
		},
	},
});
const handleScroll = () => {
	const scrollTop = window.scrollY;
	show_scroll_to_top_button.value = scrollTop > 100;
};

const handleElementScroll = () => {
	const container = document.querySelector('.live-tab-info');

	if (container) {
		const scrollTop = container.scrollTop;
		show_scroll_to_top_button.value = scrollTop > 100;
	}
};

const selectPrimaryOverviewMarket = (overview_market) => {
	primary_overview_market.value = overview_market;
	show_primary_overview_market.value = false;
}

const selectSecondaryOverviewMarket = (overview_market) => {
	secondary_overview_market.value = overview_market;
	show_secondary_overview_market.value = false;
}

const closePrimaryOverviewMarketSelector = () => {
	show_primary_overview_market.value = false;
}

const closeSecondaryOverviewMarketSelector = () => {
	show_secondary_overview_market.value = false;
}

function handleSnapshot() {
	if (router.currentRoute.value.name != 'live-sports-overview') return;

	// Set first fixture of overview to diplay it in virtual live
	virtualCourtStore.setFixtureInQueue(liveSportOverviewStore.getFirstFixture);
}

onMounted(() => {

	const el = document.querySelector('.overview-markets-container');

	window.addEventListener('scroll', () => {
		if (window.scrollY >= 80) {
			el.classList.add('is-stuck');
		} else {
			el.classList.remove('is-stuck');
		}
	});

	if (liveSportsStore.selected_live_sport_id) {
		liveSportOverviewStore.loading = true;
		socketStore.join('liveSportOverview', liveSportsStore.selected_live_sport_id);

		if (useLandingSportsStore().getSelectedOverviewMarket) {
			primary_overview_market.value = useLandingSportsStore().getSelectedOverviewMarket;
			secondary_overview_market.value = useLandingSportsStore().getSelectedOverviewMarket;

			setTimeout(() => {
				useLandingSportsStore().selected_overview_market = null
			}, 400);
		} else {
			let sport_overview_markets = marketsStore.sportOverviewMarkets(liveSportsStore.selected_live_sport_id);
			if (sport_overview_markets.length > 1) {
				primary_overview_market.value = sport_overview_markets[0];

				secondary_overview_market.value = sport_overview_markets[1]
			} else {
				primary_overview_market.value = sport_overview_markets[0];
				secondary_overview_market.value = sport_overview_markets[0]
			}
		}
	}

	window.addEventListener('scroll', handleScroll);
	const container = document.querySelector('.live-tab-info');

	if (container) {
		container.addEventListener('scroll', handleElementScroll);
	}

	document.title = generalStore.getGeneral.site_name + ' - ' + t('general.live_sports');

	emitter.on('liveSportOverview', handleSnapshot)
});

onBeforeUnmount(() => {
	socketStore.leave('liveSportOverview');
	liveSportOverviewStore.emptyLiveSportsOverview();
	emitter.off('liveSportOverview', handleSnapshot)
})

watch(() => liveSportsStore.selected_live_sport_id, (newSportId, oldSportId) => {
	if (newSportId > 0) {
		liveSportOverviewStore.emptyLiveSportsOverview();

		// Find first overview market of new selected live sport id
		socketStore.join('liveSportOverview', newSportId);
		liveSportOverviewStore.loading = true;

		if (useLandingSportsStore().getSelectedOverviewMarket) {
			primary_overview_market.value = useLandingSportsStore().getSelectedOverviewMarket;
			secondary_overview_market.value = useLandingSportsStore().getSelectedOverviewMarket;

			setTimeout(() => {
				useLandingSportsStore().selected_overview_market = null
			}, 400);

			return;
		}

		let sport_overview_markets = marketsStore.sportOverviewMarkets(newSportId);
		if (sport_overview_markets.length > 1) {
			primary_overview_market.value = sport_overview_markets[0];

			secondary_overview_market.value = sport_overview_markets[1]
		} else {
			primary_overview_market.value = sport_overview_markets[0];
			secondary_overview_market.value = sport_overview_markets[0]
		}

	} else if (newSportId == null) {
		socketStore.leave('liveSportOverview');
		liveSportOverviewStore.emptyLiveSportsOverview();
	}
})

// If no more favourites selected select 1st sport of live sports
watch(() => favouritesStore.liveSportOverviewFavourites, (newValue, oldvalue) => {
	if (!liveSportsStore.favouritesSelected) return;

	if (Object.keys(newValue) == 0) {
		liveSportsStore.selectFavourites(false);
		liveSportsStore.setSelectedLiveSportId(liveSportsStore.liveSports[0].id);
	}
})

watch(() => liveSportOverviewStore.overviewFixturesKeys, (newValue, oldvalue) => {
	if (newValue == null) return;

	if (!newValue.includes(String(virtualCourtStore.selectedFixture?.id))) {
		virtualCourtStore.setFixtureInQueue(liveSportOverviewStore.getFirstFixture)
	}
})

watch(() => liveSportOverviewStore.overviewFixturesCountWithLive, (newValue, oldvalue) => {
	if (newValue == null) return;
	if (newValue == 0) liveSportOverviewStore.setShowVideoFixtures(false);
})
</script>
<template>
	<template v-if="!liveSportsStore.favouritesSelected">
		<div class="live-bet-dashboard round-game-liveSport round-games-main set_game-outer">
			<div class="bet-dashboard-top">
				<div class="dashboard-info-label bet-tab-title">
					<div class="sport-title">
						<svg class="normal-img"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:23px; fill: none; stroke: var(--white); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 30 25"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="liveSportsStore.liveSportSvg(liveSportsStore.selected_live_sport_id) + '#svg3108'" stroke-width="1px"  />
						</svg>
						<h6>{{ liveSportsStore.getSelectedLiveSportName }} {{ liveSportOverviewStore.overviewFixturesCount ? '(' +  liveSportOverviewStore.overviewFixturesCount + ')' : '' }}</h6>
					</div>

					<div class="live-badge" v-html="svg_data.live_badge"></div>
				</div>
				<div class="mobile-info-label">
					<svg class="normal-img"
							xmlns="http://www.w3.org/2000/svg"
							xml:space="preserve"
							version="1.1"
							style="width:23px; fill: none; stroke: var(--primary); shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
							viewBox="0 0 30 25"
							xmlns:xlink="http://www.w3.org/1999/xlink">
							<use :xlink:href="liveSportsStore.liveSportSvg(liveSportsStore.selected_live_sport_id) + '#svg3108'" stroke-width="1px"  />
						</svg>
					<h3>{{ liveSportsStore.getSelectedLiveSportName }} {{ liveSportOverviewStore.overviewFixturesCount ? '(' +  liveSportOverviewStore.overviewFixturesCount + ')' : '' }}</h3>
				</div>

				<div class="dashboard-info-label dropdown-option-top" v-if="primary_overview_market">
					<div class="select-option">
						<dl class="drop" :class="show_primary_overview_market ? 'active' : ''">
							<span class="tabIco">
								<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
									<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
										<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
									</g>
								</svg>
							</span>
							<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
								<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_primary_overview_market = !show_primary_overview_market"  v-click-outside-element="closePrimaryOverviewMarketSelector">{{ primary_overview_market.name.toUpperCase() }}</button>
							</dt>
							<dd>
								<ul>
									<li v-for="overview_market in marketsStore.sportOverviewMarkets(liveSportsStore.selected_live_sport_id)" :key="overview_market.slug" @click="selectPrimaryOverviewMarket(overview_market)" :class="primary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
										<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market.name.toUpperCase() }}</button>
										<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(liveSportsStore.selected_live_sport_id, overview_market)">
											<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
												<path :style="{ fill: favouritesStore.isOverviewFavourite(liveSportsStore.selected_live_sport_id, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
											</svg>
										</div>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
				</div>

				<div class="dashboard-info-label dropdown-option-top dropdown-option-top-2" v-if="secondary_overview_market">
					<div class="select-option">
						<dl class="drop" :class="show_secondary_overview_market ? 'active' : ''">
							<span class="tabIco">
								<svg xmlns="http://www.w3.org/2000/svg" width="4" height="3" viewBox="0 0 4 3">
									<g id="Group_73" data-name="Group 73" transform="translate(-134 -568)">
										<path id="Polygon_2" data-name="Polygon 2" d="M2,0,4,3H0Z" transform="translate(138 571) rotate(180)" fill="var(--white)" />
									</g>
								</svg>
							</span>
							<dt style="display: flex; align-items: center; justify-content: space-between; padding-right: 15px;">
								<button class="tablinks" style="flex-grow: 1; text-align: left;" @click="show_secondary_overview_market = !show_secondary_overview_market"  v-click-outside-element="closeSecondaryOverviewMarketSelector">{{ secondary_overview_market.name.toUpperCase() }}</button>
							</dt>
							<dd>
								<ul>
									<li v-for="overview_market in marketsStore.sportOverviewMarkets(liveSportsStore.selected_live_sport_id)" :key="overview_market.slug" @click="selectSecondaryOverviewMarket(overview_market)" :class="secondary_overview_market.slug == overview_market.slug ? 'active' : ''" style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
										<button class="tablinks" style="flex-grow: 1; text-align: left;">{{ overview_market.name.toUpperCase() }}</button>
										<div class="live-fav-icon" style="cursor: pointer; padding-left: 10px; display: flex; align-items: center;" @click.stop="favouritesStore.toggleFavouriteOverviewMarket(liveSportsStore.selected_live_sport_id, overview_market)">
											<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 12 11.143">
												<path :style="{ fill: favouritesStore.isOverviewFavourite(liveSportsStore.selected_live_sport_id, overview_market) ? 'var(--primary)' : 'var(--tab-gray)' }" id="Icon_ionic-ios-star" data-name="Icon ionic-ios-star" d="M12.67,5.545H8.729l-1.2-3.573a.434.434,0,0,0-.814,0l-1.2,3.573H1.554a.43.43,0,0,0-.429.429.315.315,0,0,0,.008.072.412.412,0,0,0,.179.3L4.551,8.63,3.308,12.244a.43.43,0,0,0,.147.482.414.414,0,0,0,.241.1.525.525,0,0,0,.268-.1l3.161-2.253,3.161,2.253a.5.5,0,0,0,.268.1.385.385,0,0,0,.238-.1.425.425,0,0,0,.147-.482L9.7,8.63l3.212-2.3.078-.067a.449.449,0,0,0,.139-.287A.454.454,0,0,0,12.67,5.545Z" transform="translate(-1.125 -1.688)" />
											</svg>
										</div>
									</li>
								</ul>
							</dd>
						</dl>
					</div>
				</div>

				<div class="toggle-markets" :class="{'video-icon-selected': liveSportOverviewStore.show_video_fixtures}">
					<LiveIcon v-if="liveSportOverviewStore.overviewFixturesCountWithLive > 0" @click="showVideoFixtures"/>
					<span class="toggle-markets">
						<div @click="competitions_closed = !competitions_closed" class="markets-toggle-fill">
							<svg v-if="!competitions_closed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" svg-inline="" title="Toggle" role="presentation" focusable="false" xmlns:xlink="http://www.w3.org/1999/xlink" class="markets-toggle-svg">
								<use xlink:href="/assets/icons/markets_close.svg#markets_close"></use>
							</svg>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" svg-inline="" title="Toggle" role="presentation" focusable="false" xmlns:xlink="http://www.w3.org/1999/xlink" class="markets-toggle-svg">
								<use xlink:href="/assets/icons/markets_open.svg#markets_open"></use>
							</svg>
						</div>
					</span>
				</div>
			</div>

			<div class="overview-markets-container">
				<Splide :options="splideOptions">
					<SplideSlide v-for="market in marketsStore.sportOverviewMarkets(liveSportsStore.selected_live_sport_id)" :key="market.id">
						<span class="market-name" :class="{ 'is-active': market.slug == primary_overview_market?.slug }" @click="selectPrimaryOverviewMarket(market)">{{ market.name }}</span>
					</SplideSlide>
				</Splide>
			</div>

			<div class="live-tab-info live-overview-fixtures" style="min-height:300px;">
				<Loader v-if="liveSportOverviewStore.loading"></Loader>

				<div v-else id="overview" class=" overview-live">
					<LiveSportOverviewCompetition v-for="(competition, index) in liveSportOverviewStore.overviewFixtures" :key="index"
						:competition="competition"
						:competitions_closed="competitions_closed"
						:primary_overview_market="primary_overview_market"
						:secondary_overview_market="secondary_overview_market"
						:odd_animation="liveSportOverviewStore.overviewFixturesCount > 120 ? false : true"
					/>
				</div>
			</div>
		</div>
	</template>
	<template v-else>
		<LiveSportOverviewFavourites v-for="(sport, index) in favouritesStore.liveSportOverviewFavourites" :key="index" :sport_overview="sport"/>
	</template>
	<button @click="scrollToTop" type="button" class="btn scroll-to-top" id="btn-back-to-top" v-show="show_scroll_to_top_button">
		<i class="fas fa-arrow-up"></i>
	</button>
</template>

<style scoped>

.sports-main .sports-main-outer .toggle-markets {
	display: flex;
    margin-left: auto;
    cursor: pointer;
    align-items: center;
}
@media screen and (min-width: 767px)  {
   .overview-markets-container {
		display: none;
   }
}


.overview-markets-container.is-stuck {
    background: var(--dark-gray);
    top: 50px;
    padding-top: 10px;
    height: 48px;
}
.overview-markets-container{

	margin-top: 12px;

	border-bottom: 1px solid var(--tab-gray);
	position: sticky;
    top: 100px;
    z-index: 10;
	transition: top 0.2s ease;
}

.overview-markets-container.is-stuck {
	background: var(--dark-gray);
	top: 50px;
    padding-top: 10px;
    height: 48px;
}
.market-name {
	color: var(--white);
	font-size: 12px;
	cursor: pointer;
	display: inline-block;
	position: relative;
	transition: color 0.3s ease;
	white-space: nowrap;
}

.market-name.is-active {
	color: var(--market-tab-active-color, var(--white));
	font-weight: 600;
}

.market-name.is-active::after {
	content: "";
	position: absolute;
	bottom: -2px;
	left: 0;
	width: 100%;
	height: 3px;
	background-color: var(--market-sub-line-color, var(--primary));
	border-radius: 2px 2px 0 0;
}

:deep(.splide__arrow:disabled) {
	display: none !important;
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	:deep(.splide__arrows .splide__arrow--next) {
		right: 0px !important;
	}
}

@media screen and (min-width: 320px) and (max-width: 767px) {
	:deep(.splide__arrows .splide__arrow--prev) {
		left: 0px !important;
	}
}

@media screen and (min-width: 320px) and (max-width: 991px) {
	.live-tab-info{
		max-height: unset!important;
		position: unset!important;

	}
}
@media screen and (min-width: 992px) and (max-width: 3000px) {
	button#btn-back-to-top {
		display:none;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		bottom: 95px;
		left: 20px;
	}
}
@media screen and (min-width: 320px) and (max-width: 767px) {
	svg.svg-inline--fa.fa-arrow-up.fa-w-14 {
		margin-bottom: 7px!important;
	}
	button#btn-back-to-top {
		width: 30px!important;
		height: 30px!important;
		font-size: 14px!important;
	}
}
button#btn-back-to-top {
	background: var(--primary);
	color: var(--buttons-text-color);
	width: 38px;
	height: 38px;
	border: none;
	border-radius: 50%;
	position: fixed;
	z-index: 99;
	box-shadow: 0 2px 4px var(--list-gray);
	font-size: 16px;
	cursor: pointer;
}
html[dir="rtl"] button#btn-back-to-top {
	left: unset;
	right:20px;
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	button#btn-back-to-top {
		left: 10px;
	}
}
@media screen and (min-width: 320px) and (max-width: 991px) {
	html[dir="rtl"] button#btn-back-to-top {
		left: unset;
		right:10px;
	}
}
.sports-main .live_Sports-main-outer .live-sports-center .bet-tab-title .sport-title h6 {
	color: var(--white);
}

.dropdown-option-top {
	display: block !important;
}


@media screen and (min-width: 320px) and (max-width: 767px) {
   .dropdown-option-top {
        display: none !important;
    }
}

@media screen and (min-width: 320px) and (max-width: 1600px) {
	.dropdown-option-top {
		display: block ;
	}

	.dropdown-option-top-2 {
		display: none !important;
	}

	.live-bet-dashboard .live-tab-info .live-info-outer .live-info-inner .match-goal-top {
		display: none;
	}

}

@media screen and (min-width: 320px) and (max-width: 767px) {
	.sports-main .live_Sports-main-outer .live-sports-center .live-bet-dashboard .bet-dashboard-top .mobile-info-label {
		display: grid;
		grid-template-columns: 12% 88%;
		grid-gap: 20%;
	}

	.sports-main .live_Sports-main-outer .live-sports-center .live-bet-dashboard.round-game-liveSport .bet-dashboard-top {
		grid-template-columns: auto auto;
		justify-content: space-between;
	}
}

.overview-live {
	overflow-x: hidden;
	transform: translate3d(0, 0, 0);
	-webkit-transform: translate3d(0, 0, 0);
}

.live-tab-info {
	scrollbar-width: none !important;
}
@media screen and (min-width: 1191px) and (max-width: 1600px) {
	.sports-main .live_Sports-main-outer .live-sports-center .live-bet-dashboard.round-game-liveSport .bet-dashboard-top {
		grid-template-columns: 1.9fr 1fr 1.2fr;
	}
}




html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
	rotate: 180deg;
	left: -10px;
	top: -15px;
	display: flex;
	right: unset;
}

html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
	rotate: 180deg;
	top: -15px;
	right: 0px;
}


@media screen and (min-width: 320px) and (max-width: 767px) {

	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
		left: 0px !important;
		right: unset !important;

	}

	html[dir="rtl"].overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
		rotate: 180deg !important;
		right: 0px !important;
		left: unset !important;
	}

}

@media screen and (min-width: 768px) and (max-width: 1280px) {
	html[dir="rtl"] .overview-markets-container :deep(.splide__arrows .splide__arrow--next) {
		left: 0px;
		right: unset !important;
	}

html[dir="rtl"].overview-markets-container :deep(.splide__arrows .splide__arrow--prev) {
		rotate: 180deg !important;
		right: 0px !important;
		left: unset !important;
	}

}

</style>

<!-- Non-scoped: ::-webkit-scrollbar pseudo-elements don't work with Vue scoped styles -->
<style>
/* Custom scrollbar for live overview fixtures list */
.live-tab-info.live-overview-fixtures {
	/* max-height: calc(100vh - 180px) !important; */
	overflow-y: auto !important;
	overflow-x: hidden !important;
	scrollbar-width: thin !important;
	scrollbar-color: var(--primary) transparent !important;
}
.live-tab-info.live-overview-fixtures::-webkit-scrollbar-button {
	display: none !important;
	width: 0 !important;
	height: 0 !important;
}


</style>
